import React from 'react';
import PropTypes from 'prop-types';
import { isBackgroundDark } from '../../../../../src/web/utils/colors';
import displayOpts from './displayOpts';
import style from './styles.scss';

const propTypes = {
  id: PropTypes.string,
  hideOnMobile: PropTypes.bool,
  displayOpt: PropTypes.string,
  stacked: PropTypes.bool,
  fullWidth: PropTypes.bool,
  placeholder: PropTypes.string,
  pageType: PropTypes.string,
  sectionStyle: PropTypes.shape({}),
  whiteOr: PropTypes.bool,
};

const defaultProps = {
  id: undefined,
  hideOnMobile: false,
  displayOpt: displayOpts.find(opt => opt.default).value,
  stacked: false,
  fullWidth: false,
  placeholder: undefined,
  pageType: undefined,
  sectionStyle: undefined,
  whiteOr: undefined,
};

const StorageMartSearchGeo = ({
  id,
  displayOpt,
  hideOnMobile,
  stacked,
  fullWidth,
  placeholder,
  pageType,
  sectionStyle,
  whiteOr,
}) => {
  const isMobile = /Mobi/.test(navigator.userAgent);
  if (isMobile && hideOnMobile) {
    return null;
  }

  const widgetId = id;
  const darkBackground = isBackgroundDark(sectionStyle && sectionStyle.backgroundColor);

  const { component } = displayOpts.find(opt => opt.value === displayOpt);

  return (
    <div className={`mt-4  ${style.searchBarContainer} ${fullWidth ? style.fullWidth : ''}`}>
      {React.cloneElement(component, {
        stacked, placeholder, pageType, darkBackground, widgetId, whiteOr,
      })}
    </div>
  );
};

StorageMartSearchGeo.propTypes = propTypes;
StorageMartSearchGeo.defaultProps = defaultProps;

export default StorageMartSearchGeo;
